import React, { useContext, useEffect, useRef, useState } from "react";
import { ERROR_MESSAGES } from "../../../components/common/GlobalMassssage";
import Select from "react-select";

import {
  AddUpdateClientGroup,
  GetClientGroupModel,
} from "../../../services/ClientGrouping/ClientGroupingApi";
import SuccessModal from "../../../components/common/SuccessModal";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";
import { GetCustomerIndustryLookupList } from "../../../services/CustomerIndustry/CustomerIndustryApi";

const AddUpdateClientGroupingModal = ({
  isOpen,
  onClose,
  setIsAddUpdateDone,
  modelRequestData,
}) => {
  const inputRef = useRef(null);
  const ModuleName = "Predefined";
  const [groupName, setClientGroupingName] = useState("");
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [customerIndustryID, setCustomerIndustryID] = useState("");
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [customerIndustryOptions, setcustomerIndustryOptions] = useState([]);
  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
      GetCustomerIndustryLookupListData();
    }
  }, [isOpen]);

  const GetCustomerIndustryLookupListData = async () => {
    try {
      const adminKeyID = authDetails?.adminKeyID;
      if (!adminKeyID) return;

      let response = await GetCustomerIndustryLookupList(adminKeyID);

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const customerIndustryOption = response?.responseData?.data.map(
          (val) => ({
            value: val.customerIndustryID,
            label: val.customerIndustryName,
          })
        );
        console.log("Mapped Options:", customerIndustryOption); // Confirm correct mapping

        setcustomerIndustryOptions(customerIndustryOption);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching market lookup list:", error);
    }
  };

  //getModel
  useEffect(() => {
    setModelAction(modelRequestData.Action === null ? "Add" : "Update"); //Do not change this naming convention
    if (
      modelRequestData.KeyID !== undefined &&
      modelRequestData.KeyID !== null &&
      modelRequestData.Action === "Update"
    ) {
      GetClientGroupingModelData(modelRequestData.KeyID);
    } else {
      setClientGroupingName("");
    }
    setErrorMessage("");
  }, [modelRequestData]);
  if (!isOpen) return null;

  //Get Model
  const GetClientGroupingModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetClientGroupModel(
      ModuleName,
      KeyID,
      authDetails.adminKeyID
    );
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      setClientGroupingName(ModalData.clientGroupName);
      setCustomerIndustryID(ModalData.customerIndustryID); // Set the customerIndustryID from the response
    } else {
      setLoader(false);
    }
  };
  const handleSubmit = async () => {
    if (
      groupName === undefined ||
      groupName === null ||
      groupName === "" ||
      customerIndustryID === undefined ||
      customerIndustryID === null ||
      customerIndustryID === ""
    ) {
      setRequireErrorMessage(true);
      return false;
    }
    setLoader(true);
    try {
      const data = await AddUpdateClientGroup({
        adminKeyID: authDetails.adminKeyID,
        clientGroupName: groupName,
        clientGroupKeyID: modelRequestData.KeyID,
        ModuleName: ModuleName,
        customerIndustryID: customerIndustryID,
      });
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
        // onClose(); // Close the StaffRoleModal
        setShowSuccessPopupModal(true); // Show the SuccessModal
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <>
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        onClick={onClose}
        aria-hidden={!isOpen}
      >
        <div
          className="bg-white rounded-lg shadow-lg w-full max-w-md"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
        >
          {/* Modal Header */}
          <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
            <h2 className="text-16 font-semibold">
              {modelAction} Client Grouping
            </h2>
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={onClose}
              aria-label="Close Modal"
            >
              ✕
            </button>
          </div>

          {/* Modal Body */}
          <div className="p-6 grid grid-cols-1 gap-2">
            {" "}
            {/* Change gap-4 to gap-0 */}
            {/* Customer Industry Select */}
            <div className="mb-0 w-full">
              {" "}
              {/* Change mb-4 to mb-0 */}
              <label className="block text-12 text-gray-700 mb-1">
                Customer Industry <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                options={customerIndustryOptions}
                className="w-full text-12"
                placeholder="Select Customer Industry"
                value={customerIndustryOptions.find(
                  (option) => option.value === customerIndustryID
                )}
                onChange={(selectedOption) => {
                  setCustomerIndustryID(
                    selectedOption ? selectedOption.value : ""
                  );
                }}
              />
              {requireErrorMessage &&
              (customerIndustryID === "" ||
                customerIndustryID === undefined ||
                customerIndustryID === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>
            {/* Role Name Input */}
            <div className="mb-0 w-full">
              {" "}
              {/* Change mb-4 to mb-0 */}
              <label className="block text-12 text-gray-700 mb-1">
                Grouping Name<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                maxLength={30}
                className="w-full p-2 border rounded-md text-12"
                placeholder="Enter Grouping Name"
                value={groupName}
                onChange={(e) => {
                  let value = e.target.value;

                  // Capitalize the first letter if the input is not empty
                  if (value.length > 0) {
                    value = value.charAt(0).toUpperCase() + value.slice(1);
                  }

                  // Allow only letters at the start, then letters & spaces after the first character
                  if (/^[A-Za-z][A-Za-z\s]*$/.test(value) || value === "") {
                    setClientGroupingName(value);
                  }
                }}
              />
              {requireErrorMessage &&
              (groupName === "" ||
                groupName === undefined ||
                groupName === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>
          </div>

          {errorMessage && (
            <div className="text-center mb-2">
              <label className="validation ">{errorMessage}</label>
            </div>
          )}

          {/* Modal Footer */}
          <div className="bg-gray-100 px-6 py-4 border-t flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 bg-gray-300 rounded-md text-12"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              onClick={() => handleSubmit()}
              className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-12"
            >
              Submit
            </button>
          </div>
        </div>

        <SuccessModal
          isOpen={showSuccessPopupModal}
          onClose={() => {
            onClose();
            setShowSuccessPopupModal(false);
          }}
          modelAction={modelAction}
          actionMessage={groupName}
        />
      </div>
    </>
  );
};

export default AddUpdateClientGroupingModal;
